import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";

import { Helmet } from "react-helmet-async";

import AdminInterestContext from "../../context/adminInterest/adminInterestContext";

import LoadingSpinner from "../../components/utilities/LoadingSpinner";
import InterestForm from "../../components/interestAdmin/InterestForm";

const InterestFormPage = () => {
  const { id } = useParams();
  const adminInterestContext = useContext(AdminInterestContext);
  const { getEntrie, entrie, clearEntrie } = adminInterestContext;

  useEffect(() => {
    getEntrie(id);
    return () => {
      clearEntrie();
    };
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Request Information</title>
      </Helmet>
      <div id="interest-form-page">
        <div className="container">
          {Object.keys(entrie).length !== 0 ? (
            <InterestForm formData={entrie} />
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default InterestFormPage;
